import AbstractApiRepository from '~/base/api/AbstractApiRepository';

import { RefreshTokenDto } from './dto/RefreshTokenDto';

export default class RefreshTokenApiRepository extends AbstractApiRepository {
  refreshAccessToken = (data: RefreshTokenDto) => {
    return this.apiClient.post({
      url: '/identity/refresh/token',
      data,
    });
  };
}
